import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";

import { format } from "date-fns";

import { IIntegrationsStatus } from "@/jenesys-types/jenesys-entities/config";

interface Props {
  isOpen: boolean;
  accountingStatus?: IIntegrationsStatus;
  onClose: () => void;
  updateVATStatus: () => void;
}

export const VATWarning = ({
  isOpen,
  accountingStatus,
  onClose,
  updateVATStatus
}: Props) => {
  const connectionDate = accountingStatus?.last_refreshed
    ? format(accountingStatus?.last_refreshed!, "do MMMM, yyyy")
    : "";

  return (
    <Modal size="lg" isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay />
      <ModalContent rounded={16} py={6} px={6}>
        <ModalHeader pb={0} fontSize={20} color="secondary.600">
          VAT Registration Conflict
        </ModalHeader>
        <ModalCloseButton top={10} right={12} />
        <ModalBody fontWeight={500} fontSize="sm">
          {!!connectionDate && `On ${connectionDate},`}
          <Box as="span" textTransform="capitalize">
            &nbsp;{accountingStatus?.name}&nbsp;
          </Box>
          indicated that&nbsp;
          {accountingStatus?.tenant_name || "this client"} was VAT registered.
          Are you sure you would like to make changes? You will have to make
          changes in
          <Box as="span" textTransform="capitalize">
            &nbsp;{accountingStatus?.name}&nbsp;
          </Box>
          if so.
        </ModalBody>

        <ModalFooter>
          <Button
            w={157}
            h={9}
            variant="outline"
            size="sm"
            mr={5}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            onClick={updateVATStatus}
            variant="default"
            w={157}
            h={9}
            size="sm"
            color="white"
            bg="green.400"
          >
            Make changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
